import React, { useContext, useEffect } from "react";
import Hero from "../../Components/Businesses/Mad Gamers/Hero";
import Products from "../../Components/Businesses/Mad Gamers/Products";
import { AppContext } from "../../Contexts/AppContext";

const MadGamers = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "business");
    context.setCurrent("business");
  }, [context]);
  return (
    <div>
      <Hero />
      <Products />
    </div>
  );
};

export default MadGamers;
